<div
  class="py-2 d-flex justify-content-center align-items-center flex-wrap flex-{{
    orientation
  }}"
  [class.price-info--has-content-below]="hasContentBelow"
>
  @if (prefixLabel) {
    <span class="price-info--prefix-left" *scText="prefixLabel"></span>
  }
  <span class="price-info--price mx-2 mb-0 h1">
    <ng-container
      *ngTemplateOutlet="price % 1 === 0 ? roundedPrice : decimalPrice"
    ></ng-container>
  </span>
  @if (suffixLabel) {
    <span class="price-info--prefix-right" *scText="suffixLabel"></span>
  }
</div>

<ng-template #roundedPrice>
  {{ price | currency: 'EUR' : 'symbol' : '1.0-0' }},-
</ng-template>
<ng-template #decimalPrice>
  {{ price | currency: 'EUR' : 'symbol' : '1.2' }}
</ng-template>
